<template>
  <div class="action">
    <img
      src="./images/icon-gift2.png"
      alt=""
      srcset=""
      @click.stop="sendGift"
    />
    <img
      src="./images/icon-voice-close.png"
      alt=""
      srcset=""
      @click="openMic()"
      v-if="!isOpenMic"
    />
    <img
      src="./images/icon-voice.png"
      alt=""
      srcset=""
      @click="closeMic()"
      v-if="isOpenMic"
    />
    <!-- <img
      src="./images/icon-volume-close.png"
      alt=""
      srcset=""
      @click="openVolume()"
      v-if="isMute"
    />
    <img
      src="./images/icon-volume.png"
      alt=""
      srcset=""
      @click="closeVolume()"
      v-if="!isMute"
    /> -->
    <img
      src="./images/icon-call-close.png"
      alt=""
      srcset=""
      @click="leaveRoom"
    />
    <gift-vue ref="gift"></gift-vue>
    <audio ref="endAudio" src="./audio/end.mp3" loop></audio>
  </div>
</template>
<script>
import GiftVue from './gift.vue';
import mRtc from './mRtc';
import { leaveRoom as leaveRoomRequest } from './api';
import AnonymousCallProvider from './anonymousCall';

export default {
  name: 'Action',
  components: {
    GiftVue
  },
  props: {},
  data() {
    return {
      AnonymousCallProvider
    };
  },
  watch: {},
  computed: {
    isOpenMic() {
      return mRtc.isOpenMic;
    },
    isMute() {
      return mRtc.isMute;
    }
  },
  methods: {
    async openMic() {
      try {
        await mRtc.openMic();
      } catch (error) {
        console.log(error);
      }
    },
    async closeMic() {
      await mRtc.closeMic();
    },
    // async openVolume() {
    //   try {
    //     await mRtc.setVolume(60);
    //     console.log(this.isMute);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // async closeVolume() {
    //   await mRtc.setVolume(0);
    //   console.log(this.isMute);
    // },
    sendGift() {
      this.$refs.gift.init();
    },
    async leaveRoom() {
      const audio = this.$refs.endAudio;
      if (audio) {
        audio.currentTime = 0;
        audio.play();
      }
      await leaveRoomRequest({ roomUid: this.AnonymousCallProvider.roomUid });
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.action {
  width: 100%;
  display: flex;
  justify-content: space-around;
  img {
    max-width: 44px;
    flex: auto;
    object-fit: contain;
    cursor: pointer;
    &:nth-child(2) {
      max-width: 25px;
    }
    &:nth-child(3) {
      max-width: 25px;
    }
  }
}
</style>
